export enum IdenfyMethodTypes {
  APP = 'APP',
  BROWSER = 'BROWSER',
}

export enum IdenfyIframeStatus {
  FAILED = 'failed',
  APPROVED = 'approved',
}
